<!--创建广告，计划时的地域组件-->
<template>
  <div class="put-area">
    <el-checkbox
      :label="cityList.entire[0].name"
      :disabled="disableAll"
      v-model="checkedAll"
      v-if="cityList.entire"
    ></el-checkbox>
    <el-checkbox-group v-model="checkList" @change="changeCheckBox">
      <el-checkbox
        v-for="(city, index) in cityList.provinces"
        :label="city.value"
        :disabled="disableCities"
        :key="index"
      >{{city.name}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    cityList: { // 后台返的所有地域列表数据
      type: Object,
      required: true,
      default: function () {
        return {};
      }
    },
    detailInfo: { // 已选择的地域（编辑/查看时，需要传该参数）
      type: Array,
      default: function () {
        return [];
      }
    },
    payment: { // 结算方式
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkList: [],
      disableAll: false, // 是否禁用全国复选框
      disableCities: false, // 是否禁用全国以外的其他所有城市
      checkedAll: false // 全国是否被选择
    };
  },
  created () {
    if (this.$route.params.type || this.detailInfo.length > 0) {
      this.checkList = this.detailInfo;
      if (this.detailInfo.length === 1 && this.detailInfo[0] === '-1') {
        this.checkedAll = true
      }
    }
  },
  methods: {
    changeCheckBox () {
      if (this.checkList.length > 0) {
        this.disableAll = true;
      } else {
        this.disableAll = false;
      }
      this.$emit('checkedCity', this.checkList);
    }
  },
  watch: {
    detailInfo () {
      if (this.detailInfo && this.detailInfo[0] === '-1') {
        this.checkedAll = true;
      } else {
        this.checkList = this.detailInfo;
      }
    },
    payment () {
      this.checkList = [];
    },
    checkedAll () {
      if (this.checkedAll === true) {
        this.disableCities = true;
        this.checkList = ['-1'];
        this.$emit('checkedCity', this.checkList);
      } else {
        this.disableCities = false;
      }
    }
  }
};
</script>

<style lang="scss">
@include b(put-area) {
  width: 835px;
  padding: 10px;
  min-height: 20px;
  background: #f9f9f9;

  .el-checkbox {
    width: 80px;
    margin-bottom: 10px;
    margin-left: 15px;
  }

  @include e(choice) {
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
    padding-bottom: 10px;
    color: #2f6599;
  }

  @include e(choice-item) {
    display: inline-block;
    height: 20px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    color: #2f6599;
  }
}
</style>
